var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "article",
    {
      staticClass: "card roomy margin-bottom-2xl",
      staticStyle: { "--card-background": "transparent" },
    },
    [
      _c("font-awesome-icon", {
        staticStyle: {
          "--fa-secondary-opacity": "1",
          "--fa-primary-color": "var(--fa-navy)",
          "--fa-secondary-color": "var(--fa-yellow)",
        },
        attrs: { icon: _vm.$v6.duotone.faFaceConfused, size: "4x" },
      }),
      _vm._v(" "),
      _c("h1", { staticClass: "margin-y-2xs" }, [_vm._v("Jinkies!")]),
      _vm._v(" "),
      _c("p", { staticClass: "size-lg laptop:column-8 laptop:offset-2" }, [
        _vm._v(
          "\n    We don't have any Free " +
            _vm._s(_vm.titleCase(_vm.selectedFamily)) +
            " " +
            _vm._s(_vm.titleCase(_vm.selectedStyle)) +
            " icons in " +
            _vm._s(_vm.categoryLabel) +
            ". But below are the icons you get with\n    Font Awesome Pro.\n  "
        ),
      ]),
      _vm._v(" "),
      _c(
        "site-link",
        { staticClass: "button yellow", attrs: { to: "/plans" } },
        [
          _c("font-awesome-icon", {
            staticClass: "margin-right-md",
            attrs: { icon: _vm.$v6.regular.faRocketLaunch, size: "lg" },
          }),
          _vm._v("\n    Get Font Awesome Pro\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "p",
        { staticClass: "margin-top-2xl" },
        [
          _vm._v("\n    …or you can\n    "),
          _c("site-link", { attrs: { to: _vm.$search({ free: true }) } }, [
            _vm._v("view all our Free icons"),
          ]),
          _vm._v(".\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }